import React from "react";
import { useAccountState } from "../../hooks/query/useAccount";

/**
 * Injects the Immutable account from the ACCOUNT query cache as the `user`
 * prop, for class components that can't call `useAccountState` themselves.
 * @param {import("react").ComponentType} Component
 * @returns {import("react").FunctionComponent}
 */
const withAccountState = (Component) => {
  const WithAccountState = (props) => <Component {...props} user={useAccountState()} />;
  WithAccountState.displayName = `withAccountState(${Component.displayName || Component.name || "Component"})`;
  return WithAccountState;
};

export default withAccountState;
